import { Switch, Route } from 'react-router-dom';
import TaskList from './TaskList';
import TaskDetails from './TaskDetails';
import ScheduledTaskDetails from './ScheduledTaskDetails';

const TaskRoutes = () => {
  return (
    <Switch>
      <Route path={`/tasks/task/:id`} exact component={TaskDetails} />
      <Route
        path={`/tasks/scheduled-task/:id`}
        exact
        component={ScheduledTaskDetails}
      />
      <Route path="/tasks" exact component={TaskList} />
    </Switch>
  );
};

export default TaskRoutes;
